import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\FetchItemsDossierByDossierIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchItemsDossierByDossierIdController.php
* @route '/api/dossier/fetch-items-dossier/{dossier}'
*/
const FetchItemsDossierByDossierIdController44e370288ab89654e18422cbda5058de = (args: { dossier: string | number } | [dossier: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchItemsDossierByDossierIdController44e370288ab89654e18422cbda5058de.url(args, options),
    method: 'get',
})

FetchItemsDossierByDossierIdController44e370288ab89654e18422cbda5058de.definition = {
    methods: ["get","head"],
    url: '/api/dossier/fetch-items-dossier/{dossier}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\FetchItemsDossierByDossierIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchItemsDossierByDossierIdController.php
* @route '/api/dossier/fetch-items-dossier/{dossier}'
*/
FetchItemsDossierByDossierIdController44e370288ab89654e18422cbda5058de.url = (args: { dossier: string | number } | [dossier: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: args.dossier,
    }

    return FetchItemsDossierByDossierIdController44e370288ab89654e18422cbda5058de.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\FetchItemsDossierByDossierIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchItemsDossierByDossierIdController.php
* @route '/api/dossier/fetch-items-dossier/{dossier}'
*/
FetchItemsDossierByDossierIdController44e370288ab89654e18422cbda5058de.get = (args: { dossier: string | number } | [dossier: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchItemsDossierByDossierIdController44e370288ab89654e18422cbda5058de.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\FetchItemsDossierByDossierIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchItemsDossierByDossierIdController.php
* @route '/api/dossier/fetch-items-dossier/{dossier}'
*/
FetchItemsDossierByDossierIdController44e370288ab89654e18422cbda5058de.head = (args: { dossier: string | number } | [dossier: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: FetchItemsDossierByDossierIdController44e370288ab89654e18422cbda5058de.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Dossier\FetchItemsDossierByDossierIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchItemsDossierByDossierIdController.php
* @route '/api/dossier/{dossier}/item-dossier-for-modal'
*/
const FetchItemsDossierByDossierIdController4e4815a7476a27b38172d17d2d604dac = (args: { dossier: string | number } | [dossier: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchItemsDossierByDossierIdController4e4815a7476a27b38172d17d2d604dac.url(args, options),
    method: 'get',
})

FetchItemsDossierByDossierIdController4e4815a7476a27b38172d17d2d604dac.definition = {
    methods: ["get","head"],
    url: '/api/dossier/{dossier}/item-dossier-for-modal',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\FetchItemsDossierByDossierIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchItemsDossierByDossierIdController.php
* @route '/api/dossier/{dossier}/item-dossier-for-modal'
*/
FetchItemsDossierByDossierIdController4e4815a7476a27b38172d17d2d604dac.url = (args: { dossier: string | number } | [dossier: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: args.dossier,
    }

    return FetchItemsDossierByDossierIdController4e4815a7476a27b38172d17d2d604dac.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\FetchItemsDossierByDossierIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchItemsDossierByDossierIdController.php
* @route '/api/dossier/{dossier}/item-dossier-for-modal'
*/
FetchItemsDossierByDossierIdController4e4815a7476a27b38172d17d2d604dac.get = (args: { dossier: string | number } | [dossier: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchItemsDossierByDossierIdController4e4815a7476a27b38172d17d2d604dac.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\FetchItemsDossierByDossierIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchItemsDossierByDossierIdController.php
* @route '/api/dossier/{dossier}/item-dossier-for-modal'
*/
FetchItemsDossierByDossierIdController4e4815a7476a27b38172d17d2d604dac.head = (args: { dossier: string | number } | [dossier: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: FetchItemsDossierByDossierIdController4e4815a7476a27b38172d17d2d604dac.url(args, options),
    method: 'head',
})

/**
* Multiple routes resolve to \App\Http\Controllers\Dossier\FetchItemsDossierByDossierIdController::FetchItemsDossierByDossierIdController, so this export is a
* dictionary keyed by URI rather than a callable, with the verbs prefixed where two routes share a URI.
* Call a specific route with `FetchItemsDossierByDossierIdController['<key>'](...)`, or import the route by name from your
* generated `routes/` directory.
*/
const FetchItemsDossierByDossierIdController = {
    '/api/dossier/fetch-items-dossier/{dossier}': FetchItemsDossierByDossierIdController44e370288ab89654e18422cbda5058de,
    '/api/dossier/{dossier}/item-dossier-for-modal': FetchItemsDossierByDossierIdController4e4815a7476a27b38172d17d2d604dac,
}

export default FetchItemsDossierByDossierIdController